module.exports = __webpack_public_path__ + "static/antenne-3a4b844d9ab7decbd7ead7189e82f9e7.jpg";